import React from "react";
import { Shield, Clock, Star, Phone } from "lucide-react";
import { BRAND } from "@/lib/site";

const SIGNALS = [
  { I: Star, label: "Family-first premium care" },
  { I: Shield, label: "Vetted, background-checked caregivers" },
  { I: Clock, label: "24/7 care availability" },
  { I: Phone, label: BRAND.phone },
];

export default function TrustStrip() {
  return (
    <div
      data-testid="trust-strip"
      className="hidden md:block bg-navy-50/80 border-b border-navy-900/5"
    >
      <div className="container-x py-2.5 flex items-center justify-center gap-8 text-xs text-navy-600">
        {SIGNALS.map(({ I, label }) => (
          <span key={label} className="inline-flex items-center gap-2">
            <I className="h-3.5 w-3.5 text-gold-500" strokeWidth={1.75} />
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
